import React, { useState, useEffect, useCallback, Fragment } from "react";
import { useDispatch } from "react-redux";

import Container from "@material-ui/core/Container";

import pageTitle from "../../utils/pageTitle";
import NotFound from "../NotFound";
import { LOCATION_DETAILS_URL } from "../../config";
import DetailPanel from "../../components/location/DetailPanel";
import MediaPanel from "../../components/location/MediaPanel";
import MapPanel from "../../components/location/MapPanel";
import GoogleDataPanel from "../../components/location/GoogleDataPanel";
import { showErrorAlert } from "../../store/actions/alerts";
import ComponentLoader from "../../components/loader/ComponentLoader";

import makeApiRequest from "../../utils/axios/new-axios";

export default function ViewLocation(props) {
  const dispatch = useDispatch();

  const [notFound, setNotFound] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(true); //set to true for the initial loading
  const [locationDetails, setLocationDetails] = useState(null);
  const [mapCoords, setMapCoords] = useState(null);
  // const axiosInstance = new Axios();
  const locationId = props.match.params.locationId;

  useEffect(() => {
    pageTitle("Location");
    fetchLocationDetails(locationId);
    return () => {
      // axiosInstance.cancel("Component unmounted.");
    };
    // eslint-disable-next-line
  }, []); // [] is required to make sure that it runs only once

  const fetchLocationDetails = useCallback(
    async (locationId) => {
      try {
        setIsLoadingDetails(true);
        setLocationDetails(null);
        const response = await makeApiRequest({
          url: `${LOCATION_DETAILS_URL.url}/${locationId}`,
          method: LOCATION_DETAILS_URL.method,
        });
        setLocationDetails(response.data);
        pageTitle(response.data.name);
        setMapCoords({
          ...response.data.coordinates,
        });
        setIsLoadingDetails(false);
      } catch (error) {
        setIsLoadingDetails(false);

        if (!!error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          dispatch(
            showErrorAlert(
              "Location Details Fetch Error : " +
              (!!error.response
                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                : error.message)
            )
          );
        }
      }
    },
    [dispatch]
  );

  return (
    <Fragment>
      {!notFound ? (
        <Container style={{ marginTop: "20px", padding: "10px" }}>
          <ComponentLoader isLoading={isLoadingDetails} />
          {!isLoadingDetails && locationDetails && (
            <Fragment>
              <DetailPanel
                locationDetails={locationDetails}
                setMapCoords={setMapCoords}
              />
              <MediaPanel
                parentId={locationDetails.id}
                medias={locationDetails.media}
              />
              <GoogleDataPanel
                geoDetails={locationDetails.geoDetails}
                geoTypes={locationDetails.geoTypes}
              />
              <MapPanel mapCoords={mapCoords} locationId={locationDetails.id} />
            </Fragment>
          )}
        </Container>
      ) : (
        <NotFound />
      )}
    </Fragment>
  );
}
